export const APP_ROUTES = {
  // Authentication
  LOGIN: "/login",
  LOGOUT: "/logout",
  FORGET_PASSWORD: "/forgot-password",
  FORGET_VERIFY_CODE: "/forget-verify-code/:tokenId",
  RESET_PASSWORD: "/reset-password/:tokenId",
  REGISTER: "/register",
  EDIT_PROFILE: "/edit-profile",
  CHANGE_PASSWORD: "/change-password",

  // MCAP — each of these was a tab on one hub page in the admin console;
  // here they're the whole app, so each is its own top-level, sidebar-
  // navigable route. OVERVIEW is where a signed-in, granted admin lands.
  OVERVIEW: "/overview",
  ENGAGEMENT: "/engagement",
  WELLBEING: "/wellbeing",
  RESETS_CONTENT: "/resets-content",
  IMPLEMENTATION: "/implementation",
  PAYMENTS_LICENSING: "/payments-licensing",
  PLATFORM_HEALTH: "/platform-health",
  SETTINGS: "/settings",

  // WhatsApp conversations with the AI sales agent, with human takeover.
  // Needs inboxAccess, not mcapAccess (see helpers/access.js).
  INBOX: "/inbox",
};

export const getParamsAttachedRoute = (route, obj = {}) => {
  let keys = Object.keys(obj);

  if (keys?.length) {
    let objectKeys = keys;

    objectKeys.forEach(() => {
      route = route?.replace(new RegExp(/:([\d\w?])+/, "i"), (match) => {
        let formattedMatchedValue =
          match[match.length - 1] === "?"
            ? match.slice(1, match.length - 1)
            : match.slice(1);
        return obj[formattedMatchedValue];
      });
    });
    return route;
  }
  return route;
};
